// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  fileManager: path(ROOTS_DASHBOARD, '/files-manager'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  blank: path(ROOTS_DASHBOARD, '/blank'),
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
    file: path(ROOTS_DASHBOARD, '/file'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name: string) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },




  // TODO: must renamed into organization
  // ParentOrganization path
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/organization/new'),
    list: path(ROOTS_DASHBOARD, '/organization/list'),
    cards: path(ROOTS_DASHBOARD, '/parentOrganization/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/organization/${name}/edit`),
    details: (name: string) => path(ROOTS_DASHBOARD, `/organization/${name}/details`),
    branches: (name: string) => path(ROOTS_DASHBOARD, `/organization/${name}/branches`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    branch: {
      details: (parentOrgId: string, subOrgId: string) => path(ROOTS_DASHBOARD, `/organization/${parentOrgId}/branches/${subOrgId}/details`),
      parentInfo: (parentOrgId: string, subOrgId: string) => path(ROOTS_DASHBOARD, `/organization/${parentOrgId}/branches/${subOrgId}/parent-info`)
    },
    allUsers: path(ROOTS_DASHBOARD, '/users/all'),
  },

  // ParentOrganization Users path
  parentOrgUsers: {
    new: (name: string) => path(ROOTS_DASHBOARD, `/parentOrganization-users/${name}/new`),
    edit: (organizationId: string, userId: string) => path(ROOTS_DASHBOARD, `/parentOrganization-users/${organizationId}/user/${userId}/edit`),
    details: (organizationId: string, userId: string) => path(ROOTS_DASHBOARD, `/parentOrganization-users/${organizationId}/user/${userId}/details`),
  },

  // SubOrganization path
  subOrganization: {
    list: path(ROOTS_DASHBOARD, '/sub-organization/list'),
    new: (parentId: string) => path(ROOTS_DASHBOARD, `/sub-organization/${parentId}/new`),
    edit: (parentId: string, subOrgId: string) => path(ROOTS_DASHBOARD, `/sub-organization/${parentId}/${subOrgId}/edit`),
    details: (subOrgId: string) => path(ROOTS_DASHBOARD, `/sub-organization/${subOrgId}/details`),
  },

  // SubOrganization Users path
  subOrgUsers: {
    list: (parentOrgId: string, subOrgId: string) => path(ROOTS_DASHBOARD, `/sub-organization-users/${parentOrgId}/${subOrgId}/list`),
    new: (parentOrgId: string, subOrgId: string) => path(ROOTS_DASHBOARD, `/sub-organization-users/${parentOrgId}/${subOrgId}/new`),
    edit: (parentOrgId: string, subOrgId: string, userId: string) => path(ROOTS_DASHBOARD, `/sub-organization-users/${parentOrgId}/${subOrgId}/user/${userId}/edit`),
    details: (parentOrgId: string, subOrgId: string, userId: string) => path(ROOTS_DASHBOARD, `/sub-organization-users/${parentOrgId}/${subOrgId}/user/${userId}/details`),
  },

  // Products path
  products: {
    list: (parentOrgId: string, subOrgId: string) => path(ROOTS_DASHBOARD, `/products/${parentOrgId}/${subOrgId}/list`),
    new: (parentOrgId: string, subOrgId: string) => path(ROOTS_DASHBOARD, `/products/${parentOrgId}/${subOrgId}/new`),
    edit: (parentOrgId: string, subOrgId: string, productId: string) => path(ROOTS_DASHBOARD, `/products/${parentOrgId}/${subOrgId}/${productId}/edit`),
    details: (parentOrgId: string, subOrgId: string, productId: string) => path(ROOTS_DASHBOARD, `/products/${parentOrgId}/${subOrgId}/${productId}/details`),
  },

  // Orders path
  orders: {
    list: (subOrgId: string) => path(ROOTS_DASHBOARD, `/orders/list/${subOrgId}`),
    new: (subOrgId: string) => path(ROOTS_DASHBOARD, `/orders/${subOrgId}/new`),
    edit: (subOrgId: string, orderId: string) => path(ROOTS_DASHBOARD, `/orders/${subOrgId}/${orderId}/edit`),
    details: (orderId: any) => path(ROOTS_DASHBOARD, `/orders/${orderId}/details`),
  },











  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name: string) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  category: {
    root: path(ROOTS_DASHBOARD, '/category'),
    list: (subOrgId: string) => path(ROOTS_DASHBOARD, `/category/list/${subOrgId}`),
    new: path(ROOTS_DASHBOARD, '/category/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/category/${id}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/category/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/category/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/category/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  upselling: {
    root: path(ROOTS_DASHBOARD, '/upselling'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title: string) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
  admin: {
    companySettings: path(ROOTS_DASHBOARD, '/company/settings'),
    companyGeneral: path(ROOTS_DASHBOARD, '/company/settings/general'),
    companyLegal: path(ROOTS_DASHBOARD, '/company/settings/legal'),
    companyBanking: path(ROOTS_DASHBOARD, '/company/settings/banking'),
    actionLogs: path(ROOTS_DASHBOARD, '/action-logs'),
  },
};

// Agent paths
const ROOTS_AGENT = '/agent';

export const PATH_AGENT = {
  root: ROOTS_AGENT,
  orders: ROOTS_AGENT,
  orderDetail: (orderId: string | number) => path(ROOTS_AGENT, `/${orderId}`),
};

// Voice Agent paths (nested under /agent)
const ROOTS_VOICE_AGENT = '/agent/voice-queue';

export const PATH_VOICE_AGENT = {
  root: ROOTS_VOICE_AGENT,
  dashboard: ROOTS_VOICE_AGENT,
  orderDetail: (orderId: string | number) => path(ROOTS_VOICE_AGENT, `/${orderId}`),
};

export const PATH_DOCS = {
  root: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
};

export const PATH_ZONE_ON_STORE = 'https://mui.com/store/items/zone-landing-page/';

export const PATH_MINIMAL_ON_STORE = 'https://mui.com/store/items/minimal-dashboard/';

export const PATH_FREE_VERSION = 'https://mui.com/store/items/minimal-dashboard-free/';

export const PATH_FIGMA_PREVIEW =
  'https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1';
